import rentObjectGroundplanImagesService from "@/services/rentObjectGroundplanImagesService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await rentObjectGroundplanImagesService.create(formData);
      dispatch(
        "common/showSuccess",
        "Bild wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Bild für dieses Objekt konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      await rentObjectGroundplanImagesService.update(formData);
      dispatch(
        "common/showSuccess",
        "Bilddaten wurden aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Bilddaten konnte nicht aktualisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async updateWebsiteOrder({ dispatch }, formData) {
    try {
      await rentObjectGroundplanImagesService.updateWebsiteOrder(formData);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Bild-Reihenfolge konnte nicht aktualisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async updateOfferOrder({ dispatch }, formData) {
    try {
      await rentObjectGroundplanImagesService.updateOfferOrder(formData);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Bild-Reihenfolge konnte nicht aktualisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await rentObjectGroundplanImagesService.findAll(formData);
      commit("setAll", res.data);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Bild für dieses Objekt konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await rentObjectGroundplanImagesService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Bild wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Bild für dieses Objekt konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};